module.exports = __webpack_public_path__ + "img/the-factory-bloc-cover.35198702.jpg";